//# sourceMappingURL=loader.mjs.map
/// <reference types="./loader.d.mts" />
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $h from "../../../redraw_dom/redraw/dom/html.mjs";
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $length from "../../../sketch/sketch/css/length.mjs";
import { percent, px } from "../../../sketch/sketch/css/length.mjs";
import * as $h_ from "../../../sketch_redraw/sketch/redraw/dom/html.mjs";
import * as $colors from "../../ds/colors.mjs";
import * as $layout from "../../ds/components/layout.mjs";
import * as $skeleton from "../../ds/components/skeleton.mjs";
import * as $display from "../../ds/typography/display.mjs";
import { toList } from "../../gleam.mjs";

function movable_text(total, index) {
  return $css.class$(
    toList([
      $css.compose($display.sm()),
      $css.position("absolute"),
      $css.animation_name("fading-text"),
      $css.animation_timing_function("ease-in"),
      $css.animation_fill_mode("both"),
      $css.animation_delay($int.to_string(index * 4000) + "ms"),
      $css.animation_duration($int.to_string(total * 4) + "s"),
      $css.animation_play_state("running"),
      $css.animation_iteration_count("infinite"),
      $css.white_space("nowrap"),
      $css.left(percent(50)),
      $css.color($colors.light.grey_800),
    ]),
  );
}

export function loader(items) {
  let total = $list.length(items);
  return $layout.row(
    toList([$layout.justify("center")]),
    toList([]),
    toList([
      $h.div(
        toList([]),
        toList([
          $h_.div(
            $css.class$(
              toList([$css.position("relative"), $css.height(px(60))]),
            ),
            toList([]),
            $list.index_map(
              items,
              (item, index) => {
                return $h_.div(
                  movable_text(total, index),
                  toList([]),
                  toList([$h.text(item)]),
                );
              },
            ),
          ),
          $skeleton.skeleton(300, 10),
        ]),
      ),
    ]),
  );
}
